import { render } from "./DeleteDeviceModal.vue?vue&type=template&id=74042aea&scoped=true"
import script from "./DeleteDeviceModal.vue?vue&type=script&lang=js"
export * from "./DeleteDeviceModal.vue?vue&type=script&lang=js"

import "./DeleteDeviceModal.vue?vue&type=style&index=0&id=74042aea&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74042aea"]])

export default __exports__